export const roundToHundredth = (value: number) => {
  const valueTimes100 = value * 100;
  return Number(valueTimes100.toFixed(2));
};
